import { findSameMessage } from 'actions/messenger/findSameMessage'
import { SocketData } from 'actions/socket/socketReceiveDataAction'
import { MessengerTextMessageComet } from 'api/comet/comet.types'
import { prepareMessagesStructure } from 'components/page/Chat/Messenger/Messenger.functions'

import { isTimestampIncorrect } from './isTimestampIncorrect'
import { ChatMessage, ChatMessengerState } from '../ChatMessengerState'

export const addOutgoingMessage = (
  outgoingMessage: SocketData<MessengerTextMessageComet>,
  chatState: ChatMessengerState,
  chatSelectedProfileId: number
): ChatMessengerState => {
  if (isTimestampIncorrect(chatState, Number(outgoingMessage.content.time))) {
    return chatState
  }

  const sameMessage = findSameMessage(chatState.messages, outgoingMessage)

  if (!Boolean(sameMessage)) {
    const rawMessage = outgoingMessage.content

    const { user_from_id, user_to_id } = rawMessage.object

    /**
     * Происходил рендер сообщений предыдущего пользователя,
     * при этом само сообщение уже считалось как отправленное ботом,
     * поэтому не было защиты от XSS
     *
     * Также, когда у пользователя открыто несколько вкладок и одна из них чат,
     * то когда происходит получение данных, в чате отображаются сообщения другого пользователя
     */
    if (
      Number(user_from_id) !== chatSelectedProfileId &&
      Number(user_to_id) !== chatSelectedProfileId
    ) {
      return chatState
    }

    const updateMessagesList: ChatMessage[] = [
      rawMessage.object,
      ...chatState.messages,
    ]

    return {
      ...chatState,
      hasNewMessages: true,
      messages: updateMessagesList,
      messagesByDays: prepareMessagesStructure(updateMessagesList),
      updateContacts: true,
    }
  }

  console.warn('Outgoing message skipped', outgoingMessage)

  return chatState
}
